export var appVersion = function appVersion(config) {
  var pluginData = {
    'app:web:version': config.version.web
  };
  if (config.version.ssr) {
    pluginData['app:ssr:version'] = config.version.ssr;
  }
  return pluginData;
};